/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiRequestOptions } from './ApiRequestOptions';
import { BaseHttpRequest } from './BaseHttpRequest';
import type { CancelablePromise } from './CancelablePromise';
import type { OpenAPIConfig } from './OpenAPI';
import {
  request as __request,
  rpcRequest as __rpcRequest,
} from './request';

export class FetchHttpRequest extends BaseHttpRequest {

  constructor(config: OpenAPIConfig) {
    super(config);
  }

  /**
   * Request method
   * @param options The request options from the service
   * @returns CancelablePromise<T>
   * @throws ApiError
   */
  public override request<T>(options: ApiRequestOptions): CancelablePromise<T> {
    return __request(this.config, options);
  }

  public async rpcRequest<T, D, E>(
    url: string,
    method: string,
    params: D,
    options: Partial<ApiRequestOptions> = {},
  ): Promise<T> {
    return await __rpcRequest<T, D, E>(this.config, url, method, params, options);
  }
}
